import { Component } from '@angular/core';

@Component({
	selector: 'footer-component',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})

export class FooterComponent {
	year: Number = new Date().getFullYear();
	getAppUri: string = "https://itunes.apple.com/us/app/uc-units-converter/id1368701985?ls=1&mt=8";

	getAPP() {
		window.open(this.getAppUri);
	}
}